import type { KyInstance } from 'ky';

import { ensureError } from '@enterprise/core';
import type { OperationResult } from '@enterprise/types';

import { Uri } from '#constants/uri';

import type { Template } from './types/template.type';

/**
 * Inserts a new template by sending a POST request to the template insertion endpoint.
 *
 * @param instance - The KyInstance used to make HTTP requests.
 * @param data - The Template object containing the data to be inserted.
 * @returns A promise that resolves to an OperationResult indicating the outcome of the operation.
 * @throws Will throw an error if the HTTP request fails.
 */
export const insertTemplate = async (instance: KyInstance, data: Template) => {
  try {
    return await instance.post<OperationResult>(Uri.template.insertTemplate, { json: data }).json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
